export enum FloorEnum {
    First = 0,
    Second = 1
}


